import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/extensions/extensionManager.ts";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createStore, createEvent, restore } from 'effector';
import { isNotEmpty } from '@gmini/utils';
export var setExtensionsToLoad = createEvent({
  name: "setExtensionsToLoad",
  sid: "aftqnp"
});
export var extensionsToLoad$ = createStore([], {
  name: "extensionsToLoad$",
  sid: "-47vzj7"
}).on(setExtensionsToLoad, function (state, extensions) {
  return [].concat(_toConsumableArray(state), _toConsumableArray(extensions));
});
var setAutofocus = createEvent({
  name: "setAutofocus",
  sid: "-y0mj0u"
});
export var autofocus$ = restore(setAutofocus, false, {
  name: "autofocus$",
  sid: "-43wm5c"
});
export function getExtensionToLoad(extensionsToLoad) {
  return Promise.all(extensionsToLoad.map( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(extensionName) {
      var AutofocusExtension, FilteringExtension;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = extensionName;
              _context.next = _context.t0 === 'AutofocusExtension' ? 3 : _context.t0 === 'BIMSoft.Extensions.Filtering' ? 7 : 11;
              break;

            case 3:
              _context.next = 5;
              return import("./AutofocusExtension").then(function (mod) {
                return mod.AutofocusExtension;
              });

            case 5:
              AutofocusExtension = _context.sent;
              return _context.abrupt("return", {
                extensionName: extensionName,
                extension: AutofocusExtension,
                callback: {
                  onCheckboxClick: function onCheckboxClick(e) {
                    setAutofocus(e.e);
                  }
                }
              });

            case 7:
              _context.next = 9;
              return import('@bimsoft/filtering-extension').then(function (mod) {
                return mod.FilteringExtension;
              });

            case 9:
              FilteringExtension = _context.sent;
              return _context.abrupt("return", {
                extensionName: extensionName,
                extension: FilteringExtension,
                callback: {
                  callbacks: {
                    // eslint-disable-next-line no-empty-function
                    onCancel: function onCancel() {},
                    // eslint-disable-next-line no-empty-function
                    onSearch: function onSearch() {}
                  }
                }
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).filter(isNotEmpty));
}